import axios, { getData } from "../../../lib/axios"

export const registerJobseeker = async (data) => {
    return axios.post("/register_jobseekers", data).then(getData)
}

export const account = async () => {
    return axios.get("/my_accounts").then(getData)
}

export const updateAccount = async () => {
    return axios.put("/my_accounts").then(getData)
}

export const deleteAccount = async () => {
    return axios.delete("/delete_account_jobseekers").then(getData)
}

export const support = async (data) => {
    return axios.post('/support', data).then(getData);
}